import React from 'react'
import PropTypes from 'prop-types'
import { Radio as AntRadio } from 'antd'

import InputLabel from 'components/patterns/Inputs/InputLabel'
import Radio from 'components/patterns/Radio'
import Tooltip from 'components/patterns/Tooltip'
import withStyle from './RadioGroup.style.js'

const RadioGroup = ({
  className,
  radioGroupClassName,
  options,
  value,
  onChange,
  label,
  hint,
}) => (
  <div className={className}>
    {label && <InputLabel label={label} hint={hint} />}
    <AntRadio.Group
      className={radioGroupClassName}
      value={value}
      onChange={onChange}
    >
      {options.map(renderRadio)}
    </AntRadio.Group>
  </div>
)

RadioGroup.defaultProps = {
  horizontal: false,
}

RadioGroup.propTypes = {
  className: PropTypes.string,
  radioGroupClassName: PropTypes.string,
  label: PropTypes.string,
  hint: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func,
  horizontal: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.node,
      name: PropTypes.string,
      value: PropTypes.node,
      text: PropTypes.node,
      showTooltip: PropTypes.bool,
      tooltipConfig: PropTypes.shape({
        placement: PropTypes.oneOf([
          'top',
          'left',
          'right',
          'bottom',
          'topLeft',
          'topRight',
          'bottomLeft',
          'bottomRight',
          'leftTop',
          'leftBottom',
          'rightTop',
          'rightBottom',
        ]),
        title: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.element,
          PropTypes.arrayOf(PropTypes.element),
          PropTypes.node,
        ]),
        overlayClassName: PropTypes.string,
        trigger: PropTypes.oneOf(['hover', 'focus', 'click', 'contextMenu']),
        className: PropTypes.string,
        childWrapClassName: PropTypes.string,
        arrowPointAtCenter: PropTypes.bool,
        visible: PropTypes.bool,
      }),
    })
  ),
}

export default withStyle(RadioGroup)

const renderRadio = (option) => {
  const { key, name, value, text, disabled, showTooltip, tooltipConfig } =
    option
  if (showTooltip) {
    const {
      title,
      placement,
      overlayClassName,
      trigger,
      arrowPointAtCenter,
      visible,
      className,
    } = tooltipConfig
    return (
      <Tooltip
        title={title}
        placement={placement}
        overlayClassName={overlayClassName}
        trigger={trigger}
        arrowPointAtCenter={arrowPointAtCenter}
        defaultVisible={visible}
        className={`chec-tooltip ${className}`}
      >
        <AntRadio key={key} name={name} value={value} disabled={disabled}>
          {text || value}
        </AntRadio>
      </Tooltip>
    )
  }
  return (
    <Radio key={key} name={name} value={value} disabled={disabled}>
      {text || value}
    </Radio>
  )
}
